export default __webpack_public_path__ + "static/media/showtime.2bc762f4.jpg";